import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NotFound from './views/NotFound.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '*', component: NotFound, hidden: true },
    {
      path: '/',
      name: 'home',
      component: Home,
      displayNameKey: 'welcome',
    },
    {
      path: '/printable',
      name: 'printable',
      component: Home,
      displayNameKey: 'Printable',
      hidden: true,
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      displayNameKey: 'portfolio_link',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Portfolio.vue')
    }
  ]
})
